import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import * as React from 'react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import { T } from '../../../i18n/T';
import Icon, { IconColor } from '../../../media/Icon';

var CustomHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CustomHeader, _React$PureComponent);

  function CustomHeader(props) {
    var _this;

    _classCallCheck(this, CustomHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CustomHeader).call(this, props));

    _this.handleMenuClick = function (e) {
      e.stopPropagation();

      _this.onMenuClick();
    };

    _this.onSortRequested = function (order) {
      return function () {
        // FIXME: VBr, LZe This will re-render whole component every time. You should handle shouldComponentUpdate by your self...
        if (_this.props.enableSorting) {
          _this.props.setSort(order, true);
        }
      };
    };

    _this.onSortChanged = function () {
      _this.setState({
        ascSort: _this.props.column.isSortAscending() ? true : false,
        descSort: _this.props.column.isSortDescending() ? true : false,
        noSort: !_this.props.column.isSortAscending() && !_this.props.column.isSortDescending() ? true : false
      });
    };

    _this.state = {
      ascSort: false,
      descSort: false,
      noSort: true
    };
    props.column.addEventListener('sortChanged', _this.onSortChanged);
    _this.onMenuClicked = _this.onMenuClicked.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(CustomHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Sets initial sorting of columns
      this.onSortChanged();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Removes sort event listener
      this.props.column.removeEventListener('sortChanged', this.onSortChanged);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var column = this.props.column.getColDef();
      return React.createElement("div", {
        className: "customHeaderLabel",
        onClick: this.onSortRequested(this.state.noSort ? 'asc' : this.state.ascSort ? 'desc' : ''),
        title: this.props.column.getColDef().headerTooltip
      }, React.createElement(T, {
        id: this.props.displayName
      }), column.headerIcon && React.createElement(Icon, {
        iconType: column.headerIcon,
        iconHeight: 12,
        iconColor: IconColor.Inverse
      }), this.props.enableSorting && React.createElement(React.Fragment, null, this.state.ascSort && React.createElement("div", {
        className: "customHeaderSort",
        onClick: this.onSortRequested('desc')
      }, React.createElement("i", {
        className: "ag-icon-desc"
      })), this.state.descSort && React.createElement("div", {
        className: "customHeaderSort",
        onClick: this.onSortRequested('asc')
      }, React.createElement("i", {
        className: "ag-icon-asc"
      }))), this.props.enableMenu && React.createElement("div", {
        ref: function ref(menuButton) {
          _this2.menuButton = menuButton;
        },
        className: "customHeaderMenuButton",
        onClick: this.handleMenuClick
      }, React.createElement("i", {
        className: column.filter ? 'ag-icon-filter' : 'ag-icon-menu'
      })));
    }
  }, {
    key: "onMenuClicked",
    value: function onMenuClicked() {
      this.props.showColumnMenu(this.menuButton);
    }
  }, {
    key: "onMenuClick",
    value: function onMenuClick() {
      this.props.showColumnMenu(this.menuButton);
    }
  }]);

  return CustomHeader;
}(React.PureComponent);

export { CustomHeader as default };